// extracted by mini-css-extract-plugin
module.exports = {"content":"index-module_content_35u6u","footer":"index-module_footer_cd-zm"};